export enum SuccessErrorEnum {
    SUCCESS = 'success',
    ERROR = 'error',
}
